<template>
  <div>
    <h3>Scans courrier</h3>

    <div v-if="readyToRender">
      <div v-if="mailScans.hasOwnProperty('data') && mailScans.data.length > 0">
        <pagination v-if="paginationNeeded"
          :current-page="currentPage"
          :total-pages="totalPages" @click="getPageOnClick">
        </pagination>

        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th>Expéditeur</th>
              <th>Reçu le</th>
              <th>Consulté le</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(scan, index) in mailScans.data" :key="'mailscan-item-'+index" :class="{'unread': !scan.read_at, 'expired': scan.is_expired}">
              <td>{{ scan.sender }}</td>
              <td>{{ formatDate(scan.registered_at) }}</td>
              <td>{{ scan.read_at ? formatDateHour(scan.read_at) : '-' }}</td>
              <td>
                <span v-if="scan.is_expired" class="label label-expired">
                  <i class="fa fa-clock-o"></i> Expiré
                </span>
                <span v-else-if="!scan.read_at" class="label label-unread">
                  <i class="fa fa-envelope"></i> Non lu
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <pagination v-if="paginationNeeded"
          :current-page="currentPage"
          :total-pages="totalPages" @click="getPageOnClick">
        </pagination>
      </div>

      <div class="alert alert-info" v-else>
        <i class="fa fa-info-circle"></i> Aucun courrier n'a encore été ajouté pour ce client.
      </div>
    </div>

    <loader v-else></loader>
  </div>
</template>

<script type="text/babel">
  import {mapActions, mapState} from "vuex"
  import Loader from 'views/Loader'
  import Pagination from "components/Pagination"
  import dateFormatting from 'mixins/dateFormatting'
  export default {
    name: "MailScan",

    components: {
      Loader,
      Pagination
    },

    mixins: [
      dateFormatting
    ],

    data() {
      return {
        readyToRender:false
      }
    },

    methods:{
      ...mapActions("customer", ["fetchMailScans"]),

      getPageOnClick(event){
        if (event + 1 <= this.totalPages) {
          this.fetchMailScans({ page: event + 1, per_page: 25 })
        }
      }
    },

    computed:{
      ...mapState("customer", ["mailScans"]),

      paginationNeeded () {
        return this.mailScans.last_page > 1
      },
      totalPages() {
        return this.mailScans.last_page
      },
      currentPage(){
        return this.mailScans.current_page - 1
      }
    },

    created() {
      this.fetchMailScans({ per_page: 25 }).then(() => this.readyToRender = true)
    }
  }
</script>

<style lang="scss" scoped>
td, th {
  vertical-align: middle !important;
}

tr.unread td {
  font-weight: 600;
}

tr.expired td {
  color: #999;
  font-style: italic;
}

.label-unread {
  background-color: rgba(251, 85, 122, 0.15);
  color: #c0304e;
  border: 1px solid rgba(251, 85, 122, 0.4);
  font-weight: 600;
  font-size: 11px;
  padding: 3px 7px;
  border-radius: 3px;
  white-space: nowrap;
}

.label-expired {
  background-color: rgba(120, 120, 120, 0.12);
  color: #6c757d;
  border: 1px solid rgba(120, 120, 120, 0.35);
  font-weight: 600;
  font-size: 11px;
  padding: 3px 7px;
  border-radius: 3px;
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// client/components/Customer/MailScan.vue